export enum RequestedType {
  C = "Co-Location",
  R = "Request",
  V = "Visit"
}

export class RequestedTypeClass {
  static list(){
    return [
      {"key" : "C", "value" : RequestedType.C},
      {"key" : "R", "value" : RequestedType.R},
      {"key" : "V", "value" : RequestedType.V}
    ]
  }

  static getObjectFromEnum(requestedType: RequestedType){
    return RequestedTypeClass.list().filter(object => object.key == requestedType)[0]
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/models/requested-type.ts